import React, { useCallback, useEffect, useRef, useState } from 'react';
import './style.css';
import { useTranslation } from 'react-i18next';
import Spinner from '../../../global-components/src/components/spinner/spiner';
import { Smile, Trash } from 'react-feather';
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import { useAuth, useMessage } from '../../../global-components/src';
import { LIMIT_TEXT_POST as LIMIT_TEXT_POST_ENV } from '../../../utils/vars';
import EmojiPicker from '../../Textarea/Emojis';
import { errorMessage as errorMessageUtil } from '../../../global-components/src/utils/text';
import { PACOCA_API_URL } from '../../../global-components/src/utils/vars';
import PreviewSearch from '../../../pages/Settings/SearchScreen/preview-search';
import { LinkPreview } from '../../Post/Post/link-preview';
import { extractFirstUrl, extractYouTubeId, verifyLinks } from '../../../global-components/src/utils/text';
import { removeToNativeiOS } from '../../../utils/platform';
import { Edit, Images, Send, X } from 'lucide-react';
import { PercentCrop } from 'react-image-crop';
import ReactPlayer from 'react-player';
import AudioPlayer from 'react-h5-audio-player';
import { compressImage, convertHeic } from '../../../global-components/src/utils/file';
import AudioRecorderControl, { AudioRecorderControlHandle } from '../../audio-recorder/audio-recorder';
import { uploadResumableVideo } from '../../../utils/resumable-video-upload';
import { RewriteWithAIButton } from '../../rewrite-with-ai-button';
import PostDestinationSelector from '../add-post/post-destination-selector';

interface FilePreview {
    file: File;
    src: string;
    type?: string;
}

interface RepostWithTextProps {
    id_post: number | null;
}
  
const RepostWithText: React.FC<RepostWithTextProps> = ({ id_post }) => {
    const modalRef = useRef<HTMLDivElement | null>(null);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [text, setText] = useState("");
    const formRef = useRef<HTMLFormElement>(null);
    const [isLimitExceeded, setIsLimitExceeded] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState<FilePreview[]>([]);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const audioInputRef = useRef<HTMLInputElement>(null);
    const audioRecorderRef = useRef<AudioRecorderControlHandle>(null);
    const { user, token } = useAuth();
    const { t } = useTranslation();
    const closeRef = useRef<HTMLButtonElement | null>(null);
    const { setMessage } = useMessage();
    const textareaRef = useRef<HTMLTextAreaElement>(null);
    const buttonRef = useRef<HTMLDivElement | null>(null);
    const minHeight = 150;
    const [LIMIT_TEXT_POST, setLImitTextPost] = useState(LIMIT_TEXT_POST_ENV);
    const [youtubeId, setYoutubeId] = useState<string | null>(null);
    const [previewUrl, setPreviewUrl] = useState<string | null>(null);
    const [videoUrl, setVideoUrl] = useState<string | null>(null);
    const [audioUrl, setAudioUrl] = useState<string | null>(null);
    const [audioFile, setAudioFile] = useState<File | null>(null);
    const [audioRecorderActive, setAudioRecorderActive] = useState(false);
    const [imgSrc, setImgSrc] = useState<string>(""); // src da imagem para editar
    const [crop, setCrop] = useState<PercentCrop>(); // dados do crop
    const [editingIndex, setEditingIndex] = useState<number | null>(null); // qual imagem está sendo editada
    const [isCroped, setIsCroped] = useState(false); // flag de corte
    const previewCanvasRef = useRef<HTMLCanvasElement>(null);
    const [cropModalOpen, setCropModalOpen] = useState(false);
    const closeCropModal = useRef<HTMLButtonElement | null>(null);
    const openCropModal = useRef<HTMLButtonElement | null>(null);
    const imgRef = useRef<HTMLImageElement>(null);
    const [selectedCommunityIds, setSelectedCommunityIds] = useState<number[]>([]);
    const [isExpanded, setIsExpanded] = useState(false);
    const canRecordAudio = !!(user?.stamps?.includes("blue") || user?.stamps?.includes("brown"));

    useEffect(() => {
        if(user?.stamps?.includes("blue"))
            setLImitTextPost(LIMIT_TEXT_POST_ENV * 2);
    }, [user]);

    const adjustTextareaHeight = () => {
        if (textareaRef.current) {
            textareaRef.current.style.height = "auto"; // Reseta a altura para calcular corretamente
            const newHeight = Math.max(minHeight, textareaRef.current.scrollHeight); // Garante a altura mínima
            textareaRef.current.style.height = `${newHeight}px`;
        }
    };

    useEffect(() => {
        adjustTextareaHeight(); // Ajusta a altura ao montar o componente ou mudar o texto
    }, [text]);

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        const url = PACOCA_API_URL + "/posts/repost-with-text/" + id_post
        event.preventDefault(); // Impede o envio do formulário
        setLoading(true);

        if(text && verifyLinks(text)){
            setErrorMessage(t("post.suspiciousLinkPost"));
            setLoading(false);
            return;
        }
    
        // A repost can intentionally contain no added text or media.
        // The original post remains the repost's content in that case.
        setErrorMessage("");
    
        // Criação do objeto FormData
        const formData = new FormData();
        formData.append("text", text);
        selectedCommunityIds.forEach(communityId =>
            formData.append("community_ids[]", String(communityId)),
        );

        // selectedFiles.forEach(media => {
        //     if (media.type === "image") {
        //         formData.append("img[]", media.file);
        //     }

        //     if (media.type === "video") {
        //         formData.append("video", media.file);
        //     }
        // });

        try {
            const uploadPayload = [
                ...selectedFiles.map(f => ({
                    type: f.type,
                    file: f.file,
                })),
                ...(audioFile ? [{ type: "audio", file: audioFile }] : [])
            ];

            if (uploadPayload.length > 0) {
                const uploadedMedia: Array<{ type: string; path: string }> = [];
                const legacy = uploadPayload.filter(item => item.type !== 'video');
                if (legacy.length) {
                    const { data: uploadUrls } = await axios.post(PACOCA_API_URL + "/generate-upload-urls", { files: legacy }, {
                        headers: { Authorization: `Bearer ${token}` }
                    });
                    await Promise.all(uploadUrls.map((item: { url: string; path: string; type: string }, index: number) =>
                        axios.put(item.url, legacy[index].file, { headers: { 'Content-Type': legacy[index].file.type || 'application/octet-stream' } })
                    ));
                    uploadedMedia.push(...uploadUrls);
                }
                for (const item of uploadPayload.filter(item => item.type === 'video')) {
                    const uploaded = await uploadResumableVideo({
                        api: axios, apiBaseUrl: PACOCA_API_URL,
                        headers: { Authorization: `Bearer ${token}` }, file: item.file,
                    });
                    uploadedMedia.push({ type: 'video', path: uploaded.path });
                }
                uploadedMedia.forEach(item => {
                    if (item.type === "image") formData.append("images_paths[]", item.path);
                    if (item.type === "video") formData.append("video_path", item.path);
                    if (item.type === "audio") formData.append("audio_path", item.path);
                });
            }

            await axios.post(url, formData, {
                headers: {
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}` // Adicione o token aqui
                }
            })

            cancelPost()
            setMessage(t("post.shared"), "success")

            if(closeRef.current)
                closeRef.current.click()
    
        } catch (err: any) {
            const messageError = errorMessageUtil(err)
            const reason = err?.response?.data.reason && err?.response?.status == 403 ? err?.response?.data.reason : null;
            if(reason) {
                cancelPost();
                setMessage(messageError || "Erro ao enviar o aviso.", "error", undefined, undefined, reason);
            }
            else setErrorMessage(messageError);
            console.error(err);
            console.error(messageError);
            
        } finally {
            setLoading(false);
        }
    };

    const limitePost = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        const newText = event.target.value;
        setText(newText);
        setIsLimitExceeded(newText.length > LIMIT_TEXT_POST);
    }

    const cancelPost = () => {
        audioRecorderRef.current?.cancel();
        selectedFiles.forEach(f => URL.revokeObjectURL(f.src));
        setLoading(false)
        setErrorMessage("");
        setText("");
        setSelectedCommunityIds([]);
        setIsExpanded(false);
        setIsLimitExceeded(false);
        setSelectedFiles([])
        handleRemoveAudio()
        setPreviewUrl(null);
        setYoutubeId(null);
    }

    const updateText = (newText: string) => {
        setText(newText); // Atualiza o estado com o novo texto
    };

    const handleClickEmoji = () => {
        const textarea = textareaRef.current;
        if (!textarea) return;

        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;

        setText((prev) => {
            if (prev[start - 1] === ":") return prev;

            const needsSpaceBefore =
                start > 0 && prev[start - 1] !== " " && prev[start - 1] !== "\n";

            const insertText = needsSpaceBefore ? " :" : ":";

            const newText =
                prev.substring(0, start) +
                insertText +
                prev.substring(end);

            setTimeout(() => {
                const pos = start + insertText.length;

                textarea.focus();
                textarea.selectionStart = textarea.selectionEnd = pos;

                // 🔥 SIMULA DIGITAÇÃO REAL
                textarea.dispatchEvent(new Event("input", { bubbles: true }));
            }, 0);

            return newText;
        });
    };

    const handleAudioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            setAudioFile(file);
            setAudioUrl(currentUrl => {
                if (currentUrl) URL.revokeObjectURL(currentUrl);
                return URL.createObjectURL(file);
            });
        }
    };

    const handleRecordedAudio = useCallback((file: File) => {
        setAudioFile(file);
        setAudioUrl(currentUrl => {
            if (currentUrl) URL.revokeObjectURL(currentUrl);
            return URL.createObjectURL(file);
        });

        if (audioInputRef.current && typeof DataTransfer !== "undefined") {
            const transfer = new DataTransfer();
            transfer.items.add(file);
            audioInputRef.current.files = transfer.files;
        }
    }, []);

    const handleRemoveVideo = () => {
        setVideoUrl("");
        const video = document.getElementById("video") as HTMLInputElement
        video.value = "";
    };

    const handleRemoveAudio = () => {
        setAudioFile(null);
        setAudioUrl(currentUrl => {
            if (currentUrl) URL.revokeObjectURL(currentUrl);
            return "";
        });
        const audio = document.getElementById("audio") as HTMLInputElement
        if (audio) audio.value = "";
    };

    const handleMediaChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if (!files || !files.length) return;

        const processedFiles = [] as any;

        for (let file of Array.from(files)) {
            file = await convertHeic(file);
            file = await compressImage(file);
            processedFiles.push(file);
        }

        setSelectedFiles(prev => {
            const result = [...prev];

            for (const file of processedFiles) {
                const isImage =
                    file.type.startsWith("image/") ||
                    /\.(jpg|jpeg|png|gif|webp|heic|heif)$/i.test(file.name);

                const isVideo = file.type.startsWith("video/");

                if (isImage) {
                    if (result.filter(f => f.type === "image").length >= 5) continue;

                    result.push({
                        file,
                        src: URL.createObjectURL(file),
                        type: "image",
                    });
                }

                if (isVideo) {
                    result.push({
                        file,
                        src: URL.createObjectURL(file),
                        type: "video",
                    });
                }
            }

            return result;
        });

        event.target.value = "";
    };

    const handleFile = async(file: any) => {
        file = await convertHeic(file);
        file = await compressImage(file);

        const type = file.type;
        const dataTransfer = new DataTransfer(); 
    
        if (type.startsWith("image/") && fileInputRef.current?.files) {
            dataTransfer.items.add(file);
            fileInputRef.current.files = dataTransfer.files;
        
            const reader = new FileReader();
            reader.onload = (e) => {
                const src = e.target?.result;
                if (typeof src === "string") {
                    // cria um novo array baseado no estado atual
                    const newFiles = [...selectedFiles, { file, src, type: "image" }];
                    setSelectedFiles(newFiles);
                }
            };
            reader.readAsDataURL(file);

        }
            else if (type.startsWith("video/") && fileInputRef.current) {
            // remove vídeo anterior, se houver
            const filtered = selectedFiles.filter(f => f.type !== "video");

            // adiciona só o novo vídeo
            dataTransfer.items.add(file);
            fileInputRef.current.files = dataTransfer.files;

            const url = URL.createObjectURL(file);
            setSelectedFiles([...filtered, { file, src: url, type: "video" }]);
        } else if (type.startsWith("audio/") && audioInputRef.current) {
            handleRecordedAudio(file);
        }
    };
    
    const handleDrop = (e: any) => {
        e.preventDefault();
        if (e.dataTransfer?.files && e.dataTransfer.files.length > 0) {
            Array.from(e.dataTransfer.files).forEach(file => handleFile(file));
        }
    };

    useEffect(() => {
        const modal = modalRef?.current;
        const form = formRef?.current;
        const root = document.documentElement;

        if (!modal || !form || !formRef) return;

        const handleDragOver = (event: DragEvent) => {
            event.preventDefault();
            event.stopPropagation();
            if(root.classList.contains("dark"))
                modal.style.setProperty("border", "2px dashed #fff", "important");
            else
                modal.style.setProperty("border", "2px dashed #000", "important");
        };

        const handleDragLeave = (event: DragEvent) => {
            event.preventDefault();
            event.stopPropagation();
            modal.style.border = "none";
        };

        const handleDropLocal = (event: DragEvent) => {
            event.preventDefault();
            modal.style.border = "none";
            handleDrop(event)
        };

        form.addEventListener("dragover", handleDragOver);
        form.addEventListener("dragleave", handleDragLeave);
        form.addEventListener("drop", handleDropLocal);

        return () => {
            form.removeEventListener("dragover", handleDragOver);
            form.removeEventListener("dragleave", handleDragLeave);
            form.removeEventListener("drop", handleDropLocal);
        };
    }, []);
    
    const handlePaste = (e: any) => {
        if (e.clipboardData.files && e.clipboardData.files.length > 0) {
            Array.from(e.clipboardData.files).forEach(file => handleFile(file));
        }
    };

    
    const openEditor = (index: number) => {
        const fileToEdit = selectedFiles[index];
        setImgSrc(fileToEdit.src); // envia a imagem para o crop
        setEditingIndex(index);

        if (openCropModal) {
            openCropModal.current?.click();
        }
    };

    
    const handleRemoveMedia  = (index: number) => {
        setSelectedFiles(prev => {
            const file = prev[index];
            if (file?.src) URL.revokeObjectURL(file.src);

            return prev.filter((_, i) => i !== index);
        });
    };

  return (
            <form ref={formRef} className="form-post repost-composer-form" onSubmit={handleSubmit} onDrop={handleDrop} onDragOver={(e) => e.preventDefault()} id='form-repost-with-text'>
                <div className="modal fade" id="repost-with-text" aria-hidden="true">
                    <div className={`modal-dialog modal-dialog-centered rwt-dialog${isExpanded ? ' is-expanded' : ''}`}>
                        <div id="username-suggestions"></div>
                        <div className="modal-content rwt-modal-content" ref={modalRef}>
                            <div className="rwt-header">
                                <div className="rwt-title-row">
                                    <h4 className="rwt-title" id="modal-post">
                                        {t('post.repost.title', { defaultValue: 'Repost' })}
                                    </h4>
                                    <PostDestinationSelector
                                        selectedCommunityIds={selectedCommunityIds}
                                        onChange={setSelectedCommunityIds}
                                    />
                                </div>
                                <button
                                    ref={closeRef}
                                    type="button"
                                    className="rwt-close"
                                    onClick={cancelPost}
                                    data-bs-dismiss="modal"
                                    aria-label={t('generics.close', { defaultValue: 'Fechar' })}
                                >
                                    <X size={24} />
                                </button>
                            </div>
                            <div className="modal-body rwt-body">
                                <div className="user-suggestions user-suggestions-new-post" style={{display: "none", position: "absolute", background: "white", border: "1px solid #ccc", zIndex: "1000", maxHeight: "200px", overflowY: "auto", top: "254px"}}></div>
                                <textarea 
                                    ref={textareaRef}
                                    value={text} 
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        limitePost(e);

                                        const videoId = extractYouTubeId(value);
                                        setYoutubeId(videoId);
        
                                        // Link genérico (notícia, site, etc)
                                        const url = extractFirstUrl(value);
                                        setPreviewUrl(url);
                                    }}
                                    onDrop={handleDrop}
                                    onPaste={handlePaste}
                                    id="comment-text"
                                    className={`form-control text-with-emoji text-comment-big text-comment rwt-textarea ${isLimitExceeded ? "is-invalid" : ""}`}
                                    style={{ color: isLimitExceeded ? "red" : "inherit" }}
                                    placeholder={t('post.repost.textPlaceholder', { defaultValue: 'Escreva algo sobre este post...' })}
                                    onFocus={() => setIsExpanded(true)}
                                />
                                <PreviewSearch textareaRef={textareaRef} text={text} setText={setText}/>
                                <EmojiPicker
                                    textareaRef={textareaRef}
                                    updateText={updateText}
                                    text={text}
                                    buttonRef={buttonRef}
                                />

                                <div className={`div-info-textarea div-info-textarea-add-post rwt-toolbar ${audioRecorderActive ? "post-audio-toolbar-active" : ""}`} style={{border: 0}}>
                                    {!audioRecorderActive && !removeToNativeiOS(user?.id) && (
                                        <Images className='cursor-pointer icon-add-emoji' onClick={() => { fileInputRef.current?.click() }}/>
                                    )}
                                    {canRecordAudio && !removeToNativeiOS(user?.id) && (
                                        <AudioRecorderControl
                                            ref={audioRecorderRef}
                                            onRecorded={handleRecordedAudio}
                                            onError={setErrorMessage}
                                            onActiveChange={setAudioRecorderActive}
                                            audioLabel={t("chat.message.audio")}
                                            cancelLabel={t("generics.cancel")}
                                            holdLabel={t("chat.recording.holdToRecord", { defaultValue: "Segure para gravar" })}
                                            microphoneError={t("chat.microphoneError")}
                                            sendLabel={t("generics.send")}
                                        />
                                    )}
                                    {!audioRecorderActive && (
                                        <>
                                            <div className='cursor-pointer icon-add-emoji' ref={buttonRef} onClick={handleClickEmoji}>
                                                <Smile className='icon-add-emoji' />
                                            </div>

                                            <RewriteWithAIButton
                                                type="post"
                                                getText={() => text}
                                                onSuccess={setText}
                                                setError={setErrorMessage}
                                            />
                                            <div className="rwt-toolbar-spacer" />
                                            <div className={`user-select-none limite-post rwt-char-count${isLimitExceeded ? " limit" : ""}`}>
                                                {text.length}/{LIMIT_TEXT_POST}
                                            </div>
                                            <button
                                                type="submit"
                                                className="rwt-send-button"
                                                disabled={loading || isLimitExceeded}
                                                aria-label={t('generics.send')}
                                            >
                                                {loading ? <Spinner size="16px" /> : <Send size={20} />}
                                            </button>
                                        </>
                                    )}
                                </div>

                                {/* {{-- INPUT IMAGE --}} */}
                                <input type="file" ref={fileInputRef} multiple accept="image/*,video/*" onChange={handleMediaChange} style={{ display: "none" }} name='img' id='img' />

                                <input ref={audioInputRef} onChange={handleAudioChange} type="file" name='audio' id='audio' className="d-none" accept="audio/*"/>

                                <div className="invalid-feedback error-repost invalid-feedback-comment-text" style={{ display: "block" }}>
                                    {errorMessage}
                                </div>

                                <div style={{padding: "0px 10px"}}>
                                    {/* {{-- Previewa --}} */}
                                    <div className={`row row-preview-img ${selectedFiles.length > 1 ? "row-preview-img-multiple" : ""}`}>
                                        {selectedFiles.map((file, index) => (
                                            <>
                                                {file.type === "image" ? (
                                                    <div key={index} className="row-label-img ">
                                                        <div className="btn-container-add-img" style={{ marginBottom: "5px", display: "flex", gap: "5px", position: "relative" }}>
                                                            <button type="button" className="btn-edit-file-post btn-dark cursor-pointer" onClick={() => openEditor(index)}>
                                                                Editar <Edit className="icon-config-img-post" data-feather="edit"/>
                                                            </button>
        
                                                            {/* <div className="btn-remove-file-post btn-dark cursor-pointer" onClick={() => handleRemoveImage(index)}>
                                                                <Trash className="icon-config-img-post" data-feather="trash" />
                                                            </div> */}
                                                            <button type="button" onClick={() => handleRemoveMedia(index)} className="btn-x-right btn-close svg-icons-color btn-dark">
                                                                <X/>
                                                            </button>
                                                        </div>
                                                        <img alt={`preview-${index}`} src={file.src} className="label-img img-preview-add"/>
                                                    </div>
                                                ) : (
                                                    <>
                                                        <div className="row row-label-video" style={{ margin: 0, height: "100%", minHeight: selectedFiles.length > 1 ? 300 : 250, overflow: "auto", position: "relative" }}>
                                                            <button type="button" onClick={() => handleRemoveMedia(index)} className="btn-x-right btn-close svg-icons-color btn-dark">
                                                                <X/>
                                                            </button>
        
                                                            <label className="label-img label-video" style={{ minHeight: selectedFiles.length > 1 ? 300 : 0 }} htmlFor="video">
                                                                <ReactPlayer url={file.src} style={{ objectFit: "cover", minHeight: selectedFiles.length > 1 ? 300 : 250, maxHeight: selectedFiles.length > 1 ? 300 : 250 }} controls width="100%" className="video-preview" />
                                                            </label>
                                                        </div>    
                                                    </>
                                                )}
                                            </>
                                        ))}
        
                                        {/* {{-- PREVIEW VIDEO --}} */}
                                        <div className="row row-label-video" style={{ margin: 0, height: "100%", minHeight: selectedFiles.length > 1 ? 300 : 400, display: videoUrl ? "block" : "none", overflow: "auto", position: "relative" }}>
                                            <button type="button" onClick={handleRemoveVideo} className="btn-x-right btn-close svg-icons-color btn-dark">
                                                <X/>
                                            </button>
        
                                            <label className="label-img label-video" style={{ minHeight: selectedFiles.length > 1 ? 300 : 0 }} htmlFor="video">
                                                <ReactPlayer url={videoUrl || ""} style={{ objectFit: "cover", minHeight: selectedFiles.length > 1 ? 300 : 400, maxHeight: selectedFiles.length > 1 ? 300 : 400 }} controls width="100%" className="video-preview" />
                                            </label>
                                        </div>
                                    </div>
        
                                    {/* {{-- PREVIEW AUDIO --}} */}
                                    <div className="row row-label-video" style={{ margin: 0, marginTop: 5, display: audioUrl ? "block" : "none", overflow: "auto", position: "relative" }}>
                                        <div onClick={handleRemoveAudio} className="btn-x-right btn-close svg-icons-color btn-dark">
                                            <X/>
                                        </div>
        
                                        <label className="label-img label-audio" htmlFor="audio">
                                            <AudioPlayer className="audio-preview" src={audioUrl || ""} />
                                        </label>
                                    </div>

                                    {previewUrl && !youtubeId && !selectedFiles.length && (
                                        <LinkPreview url={previewUrl}/>
                                    )}

                                    {/* <LinkPreview url='https://g1.globo.com/politica/ao-vivo/pl-da-dosimetria-no-senado.ghtml'/> */}

                                    {youtubeId && !selectedFiles.length && (
                                        <iframe
                                            className='preview-ty-add-post'
                                            // width="100%"
                                            // height="315"
                                            src={`https://www.youtube.com/embed/${youtubeId}`}
                                            title="YouTube preview"
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen
                                            // style={{ borderRadius: 8 }}
                                        />
                                    )}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </form>
  );
};

export default RepostWithText;
